import React, {useContext, useEffect, useState} from 'react';
import {getLocalStorage, setLocalStorage} from './Utils';
import ApplicationContext from './ApplicationContext';
import Quote from './Quote';

const getMarketData = async(baseUrl, region) => {
	const url = baseUrl + "index.php/market_data/get_market_data/" + region;
	// console.log(`DEBUG in getMarketData:  url - ${url}`);
	const response = await fetch(url);
	const json = await response.json();

	const res = json.DATA.map((entry) => {
		return {data:entry}
	});

	return res;
};

const init = () => {
	let regionSettings = getLocalStorage("REGION_SETTING");
	if (!regionSettings) {
		setLocalStorage("REGION_SETTING", 'us');
		regionSettings = 'us';
	}
	return regionSettings;
};

const Quotes = () => {
	const [activeRegion, setActiveRegion] = useState(getLocalStorage("REGION_SETTING") ? getLocalStorage("REGION_SETTING") : 'us');
	const [marketData, setMarketData] = useState(null);
	const data = useContext(ApplicationContext);

	const activateRegion = (region) => {
		setLocalStorage('REGION_SETTING', region);
		setActiveRegion(region);
	};
	
	const [exchangeInfoMap, setExchangeInfoMap] = useState(null);
	useEffect(() => {
		data.activeRegion = init();

		((async() => {
			if (data.BASE_URL) {
				let response, exchange_info_json, quote_match_json;
    
				const get_exchange_info_url = data.BASE_URL + "index.php/misc/get_exchange_info";
				response = await fetch(get_exchange_info_url);
				exchange_info_json = await response.json();

				if (exchange_info_json?.result) {
					const get_quote_match_url = data.BASE_URL + "index.php/misc/get_quote_match";
					response = await fetch(get_quote_match_url);
					quote_match_json = await response.json();

					if (quote_match_json?.result) {
						Object.keys(quote_match_json?.result).forEach(key => {
							// console.log(`DEBUG:  ${key}`);
							const entry = quote_match_json?.result[key];
							if (entry["exchange-info"]) {
								// console.log(`DEBUG:  ${entry["exchange-info"]}`);
								let found = exchange_info_json?.result.find(e => e['headerInfo'] === entry["exchange-info"]);
								// console.log(`DEBUG:  `, found);
								if (found) {
									entry["exchange-info"] = found;
								}
							}
						});
					}
					// console.log("DEBUG: quote_match_json?.result = ", quote_match_json?.result);
					setExchangeInfoMap(quote_match_json?.result);
				}
			}
		})());
	}, [data, data.activeRegion, data.BASE_URL]);

	useEffect(() => {		
		data.activeRegion = init();
		setActiveRegion(data.activeRegion);
	}, [data, data.activeRegion, activeRegion]);

	useEffect(() => {
		setMarketData([]);
		// console.log(`DEBUG in Quotes:  data.BASE_URL changed is ${data.BASE_URL}`);
		// console.log(`DEBUG in Quotes:  activeRegion changed is ${data.BASE_URL}`);
		if (data.BASE_URL && activeRegion) {
			(async() => {
				const res = await getMarketData(data.BASE_URL, activeRegion);
				setMarketData(res);
			})();
		}
	}, [data.BASE_URL, activeRegion]);

	return (
		<>
			<h3>Market Quotes</h3>
			<div>
				<div id="region-container">
					<span className="region-align">
						<button id="us" className={"region-item " + (activeRegion === 'us' ? 'active' : '')} onClick={() => {activateRegion("us")}}>N. Amer</button>
					</span>
					<span className="region-align">
						<button id="latin-america" className={"region-item " + (activeRegion === 'latin-america' ? 'active' : '')} onClick={() => {activateRegion("latin-america")}}>Latin America</button>
					</span>
					<span className="region-align">
						<button id="europe" className={"region-item " + (activeRegion === 'europe' ? 'active' : '')} onClick={() => {activateRegion("europe")}}>EMEA</button>
					</span>
					<span className="region-align">
						<button id="asia" className={"region-item " + (activeRegion === 'asia' ? 'active' : '')} onClick={() => {activateRegion("asia")}}>APAC</button>
					</span>
					<span className="region-align">
						<button id="currencies" className={"region-item " + (activeRegion === 'currencies' ? 'active' : '')} onClick={() => {activateRegion("currencies")}}>Currencies</button>
					</span>				
					<span className="region-align">
						<button id="futures" className={"region-item " + (activeRegion === 'futures' ? 'active' : '')} onClick={() => {activateRegion("futures")}}>Futures</button>
					</span>
				</div>

				<div className={"quote-container " + (activeRegion === "currencies" ? "notranslate" : "")}>
					{marketData && marketData.map((entry,index,arr) => {
						return (
							<Quote entry={entry} key={index.toString()} exchangeInfoMap={exchangeInfoMap} />
						)
					})}
				</div>
				
				{/* TODO:  DISABLE THIS FOR NOW, IT IS NOT QUITE RIGHT.
				
				{(() => {
					const regionSettings = getLocalStorage("REGION_SETTING");
					const includeList = ['us','latin-america','europe','asia'];
					let display = false;
					if (includeList.find(e => e === regionSettings)) {
						display = true;
					}

					if (display) {
						return (<h3>Index Gap Comparison Analysis</h3>);
					}
				})()}

				{marketData && marketData.map((marketEntry,index,arr) => {
					const regionSettings = getLocalStorage("REGION_SETTING");
					let compareFromStart, display = true;

					if (regionSettings === 'us') {
						compareFromStart = [
							{"Dow Jones":["S&P 500", "Nasdaq", "Toronto"]}
						];
					}
					else if (regionSettings === 'latin-america') {
						compareFromStart = [
							{"São Paulo":["Mexico City", "Buenos Aires"]}
						];
					}
					else if (regionSettings === 'europe') {
						compareFromStart = [
							{"London":["Madrid"]},
							{"Abu Dhabi":["Istanbul", "Riyadh"]}
						];
					}
					else if (regionSettings === 'asia') {
						compareFromStart = [
							{"Bombay":["Sydney", "Seoul", "Hong Kong", "NIFTY 50", "Tokyo"]}
						];
					}
					else {
						display = false
					}
					
					if (display) {
						const res = compareFromStart.find(compareFromEntry => compareFromEntry[marketEntry.data[0]]);
						let compareFrom, includeList;
						if (res) {
							if (Object.entries(res).flat().length === 2) {
								compareFrom = marketEntry.data[0];
								includeList = Object.entries(res).flat()[1];
								
								let compare;
								let res2 = includeList.map(toEntry => {
									const foundTo = marketData.find(e => e.data[0] === toEntry);
									compare = (Number(marketEntry?.data[3]) - Number(foundTo?.data[3])) / Number(marketEntry?.data[3]) * 100;
									return (
										<>
											<div>{compareFrom} in Comparison to {foundTo?.data[0]}.</div>
											<div>({Number(marketEntry?.data[3])} - {Number(foundTo?.data[3])}) / {Number(marketEntry?.data[3])} * 100</div>
											<div>{"= " + compare.toFixed(2) + "%"}</div>
										</>
									);
								});
					
								if (res2 !== undefined) {
									return res2;
								}
							}
						}
					}
				})} */}
			</div>
		</>
	);
}

export default Quotes;
